export default "__VITE_ASSET__B6QZBq_6__"